import React from 'react';

const YOUTUBE_ICON_HOST_SIZE = 24;

const YouTubeOfficialIcon = ({
    className = '',
    style = {},
    titleAccess = 'YouTube',
    'aria-hidden': ariaHidden = true,
    ...props
}) => {
    const classes = ['yt-icon-shape', 'style-scope', 'yt-icon', 'ytSpecIconShapeHost', className]
        .filter(Boolean)
        .join(' ');

    return (
        <span
            className={classes}
            title={titleAccess}
            aria-hidden={ariaHidden}
            style={{
                width: YOUTUBE_ICON_HOST_SIZE,
                height: YOUTUBE_ICON_HOST_SIZE,
                minWidth: YOUTUBE_ICON_HOST_SIZE,
                minHeight: YOUTUBE_ICON_HOST_SIZE,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                lineHeight: 0,
                ...style,
            }}
            {...props}
        >
            <div style={{ width: '100%', height: '100%', display: 'block', fill: 'currentcolor' }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    enableBackground="new 0 0 24 24"
                    xmlSpace="preserve"
                    focusable="false"
                    aria-hidden="true"
                    style={{ pointerEvents: 'none', display: 'inherit', width: '100%', height: '100%' }}
                >
                    <g>
                        <path
                            fill="#FF0033"
                            d="M21.58,7.19c-0.23-0.86-0.91-1.54-1.77-1.77C18.25,5,12,5,12,5S5.75,5,4.19,5.42   C3.33,5.65,2.65,6.33,2.42,7.19C2,8.75,2,12,2,12s0,3.25,0.42,4.81c0.23,0.86,0.91,1.54,1.77,1.77C5.75,19,12,19,12,19   s6.25,0,7.81-0.42c0.86-0.23,1.54-0.91,1.77-1.77C22,15.25,22,12,22,12S22,8.75,21.58,7.19z"
                        />
                        <polygon fill="#FFFFFF" points="10,15 15,12 10,9" />
                    </g>
                </svg>
            </div>
        </span>
    );
};

export default YouTubeOfficialIcon;
